export default __webpack_public_path__ + "static/media/min-temp.9f77dba1.png";